module.exports = __webpack_public_path__ + "img/Menu-02.1997163d.png";